import { combineReducers } from "redux";
import authenticated from "./authenticated/reduce";
import eventCheck from "./event-check/reduce";

export default combineReducers({
  authenticated,
  eventCheck,
})